/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { combineReducers } from 'redux';
import { createAPIReducer } from './api';
import { types } from '../actions/parser';

const getParserCode = (state = {}, action) => {
  const { type, payload } = action;
  if (type === types.getParserCode) {
    return payload;
  }
  return state;
};

const getDebugResult = (state = {}, action) => {
  const { type, payload } = action;
  if (type === types.getDebugResult) {
    return payload;
  }
  return state;
};

const getParsers = createAPIReducer(types.getParsers);
const getParser = createAPIReducer(types.getParser);
const deleteParser = createAPIReducer(types.deleteParser);
const addParser = createAPIReducer(types.addParser);
const countParsers = createAPIReducer(types.countParsers);

export default combineReducers({
  getParserCode,
  getParsers,
  getParser,
  deleteParser,
  addParser,
  countParsers,
  getDebugResult,
});




// WEBPACK FOOTER //
// ./src/redux/reducers/parser.js